/**
 * Route for `api-key-header-auth`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { ApiKeyHeaderAuthPage } from "../features/api-key-header-auth/ApiKeyHeaderAuthPage";

export const apiKeyHeaderAuthRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/api-key-header-auth",
	component: ApiKeyHeaderAuthPage,
});

export default apiKeyHeaderAuthRoute;
